module.exports = __webpack_public_path__ + "static/media/avatar.30f3a862.jpg";